import React from 'react';

function Checkbox(props: any) {
  return (
    <>
      {
        props.field.options.map((option: any, index: any) => (
          <div className="form-check" key={index}>
            <input className="form-check-input" type="checkbox" required={props.field.mandatory} value={option.value} id={option.id} name={props.field.name} onChange={props.handleChange} />
            <label className="form-check-label">
              { option.label }
            </label>
          </div>
        ))
      }
    </>
  );
}

export default Checkbox;